import React, { useEffect, useState } from 'react'
import XMLViewer from 'react-xml-viewer'
import { makeStyles } from '@mui/styles'
import FileService from '@/modules/file/fileService'
import customDecodeUri from '@/utils/customDecodeUri'
import ThemeInterface from '@/theme-interface'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  root: {
    display: 'flex',
    width: '100%',
    padding: '20px 40px',
    flexDirection: 'column',
    gap: 20,
  },
  title: {
    fontSize: theme.fontSizes.medium,
  },
}))

interface ReceiptPreviewerItemXmlInterface {
  receiptUrl: string
  name: string
}

export const ReceiptPreviewerItemXml = (props: ReceiptPreviewerItemXmlInterface) => {
  const { receiptUrl, name } = props
  const classes = useStyles()

  const [xmlString, setXmlString] = useState('')

  useEffect(() => {
    if (props.receiptUrl.includes('file')) {
      FileService.fetchFileDataByUrl(props.receiptUrl)
        .then(data => {
          setXmlString(data.toString())
        })
    } else if (props.receiptUrl.startsWith('data')) {
      const base64String = props.receiptUrl.split(',')[1]
      setXmlString(Buffer.from(base64String, 'base64').toString('utf-8'))
    }
  }, [receiptUrl])

  return (
    <>
      {xmlString
      && <div className={classes.root}>
        <span className={classes.title}>{customDecodeUri(name)}</span>
        <XMLViewer xml={xmlString} collapsible />
      </div>
      }
    </>
  )
}

export default ReceiptPreviewerItemXml
